<nz-card>
  <app-search-filter [total]="queryParams.totalItems" (search$)="getValueSearch($event)">
    <div class="col-12 m-b-25">
      <div class="row">
        <div class="d-flex align-items-center">
          <i nz-icon nzType="search" class="opacity-05 mr-2"></i>
        </div>
        <div class="col-lg-3">
          <div class="d-md-flex">
            <nz-input-group>
              <input type="text" nz-input placeholder="Mã sản phẩm" [(ngModel)]="searchParams.code" 
              (ngModelChange)="eventSearchParams('code', searchParams.code)">
            </nz-input-group>
          </div>
        </div>
      </div>
    </div>
  </app-search-filter>

  <nz-divider></nz-divider>
  <nz-table #listViewTable [nzData]="list" [nzShowPagination]="false" [nzFrontPagination]="false">
    <thead>
      <tr>
        <th>Hình ảnh</th>
        <th>Tên</th>
        <th>Tên viết tắt</th>
        <th>Mã sản phẩm</th>
        <th>Loại</th>
        <th>Trạng thái</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of listViewTable.data; trackBy: trackId; index as index">
        <td>
          <img [src]="item.productGold?.imageUrl" width="100" height="100">
        </td>
        <td>{{item.name}}</td>
        <td>{{item.shortName}}</td>
        <td>{{item.code}}</td>
        <td>{{item.productGold?.goldTypeCode}}</td>
        <td>{{item?.statusId?.name}}</td>
        <td>
          <button type="button" class="btn dropdown-toggle" data-toggle="dropdown">
             <i nz-icon nzType="menu" nzTheme="outline"></i>
            <span class="sr-only">Toggle Dropdown</span>
          </button>
          <div [ngClass]="(index > list.length - 3) && list.length > 3 && 'dropup'">
          <ul class="dropdown-menu" role="menu">
            <li *ngIf="item.statusId.code !== 'PRODUCT_ACTIVE'"><a (click)="approve(item.id)" title="Edit" class="ant-btn btn-edit"><i nz-icon nzType="check" nzTheme="outline"></i><span>Duyệt</span></a></li>
            <li><a (click)="edit(item.id)" title="Edit" class="ant-btn btn-edit"><i nz-icon nzType="edit" nzTheme="outline"></i><span>Sửa đổi</span></a></li>
            <li><a (click)="confirmDelete(item)" title="Delete" class="ant-btn btn-edit"><i nz-icon nzType="stop" nzTheme="outline"></i><span>Ẩn</span></a></li>

          </ul>
          </div>
        </td>
      </tr>
    </tbody>
  </nz-table>
  <div class="ant-table-pagination ant-pagination">
    <nz-pagination [nzPageIndex]="queryParams.page" [nzTotal]="queryParams.totalItems"
      [nzPageSize]="queryParams.size" [nzShowTotal]="rangeTemplate" (nzPageIndexChange)="loadPage($event)">
    </nz-pagination>
    <ng-template #rangeTemplate let-range="range" let-total>
      {{ range[0] }} - {{ range[1] }} of {{ queryParams.totalItems }} items
    </ng-template>
  </div>
</nz-card>